/*
  Rota reserva da Riviera (tarefa 6f99acda). O João pediu em 22/09 uma página
  dentro de seulotenarepresa.com.br, sem mudar o endereço principal, "com um
  código difícil de encontrar, para ninguém acessar", sem a Momentum e com os
  botões Terrenos e Casas no lugar da marca. O caminho é aleatório de propósito
  e a página leva noindex; não é segredo forte, só fica fora de busca e de link.
*/
export const RESERVA_BASE = '/fn-f8327b1';

// Galeria "Cada gongo": o Fábio quer só os registros dele, do filho e os com a
// Regina (áudio de 22/09 15:00). Quem aparece em cada arquivo não é decidido
// aqui: lista vazia esconde a seção, nunca mostra tudo, para não publicar
// corretor de fora por padrão.
// Escolha do João na página de aprovação, 25/09: fotos 5 e 11 da galeria.
export const PROVA_RESERVA = new Set([
  '/riviera/social/gong-casais.jpg',
  '/riviera/social/assinatura-mesa.jpg',
]);

// Inventário das páginas Terrenos e Casas. O pedido é que isso venha do cadastro
// na Bianca (bianca_produtos), mas a tabela hoje só guarda a configuração do
// agente, sem preço, foto ou metragem; o desenho desses campos é decisão da
// rodada. Até lá a lista é estática e começa com o que já está à venda.
export const INVENTARIO = {
  terrenos: [
    {
      nome: 'Riviera de Santa Cristina XIII',
      local: 'Paranapanema, SP · Represa Jurumirim',
      destaque: 'Lotes a partir de R$ 150 mil',
      detalhes: ['Loteamento fechado', 'Controle de acesso 24h', 'Até 180 meses'],
      foto: '/riviera/hero-peninsula.jpg',
      href: RESERVA_BASE,
    },
  ],
  casas: [],
};
